<template>
  <page>
    <template slot="pageAction">
      <div class="actionBlock">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" @click="lifeCycle = !lifeCycle" v-on="on" id="OverviewBtn">
              Overview
              <v-icon right>mdi-file-document-box</v-icon>
            </v-btn>
          </template>
          <span>Overview</span>
        </v-tooltip>
      </div>
    </template>
    <v-navigation-drawer temporary clipped fixed right hide-overlay v-model="lifeCycle" width="450">
      <ri-Life-Cycle></ri-Life-Cycle>
    </v-navigation-drawer>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark v-if="showCoinsSvcFeeBtn" @click.prevent="doCoinsSvcFee">
          Coinsurance Service Fee
          <v-icon dark right>mdi-cash-usd</v-icon>
        </v-btn>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card>
                      <v-toolbar dense color="grey lighten-5" flat>
                        <v-icon>mdi-format-align-justify</v-icon>
                        <v-toolbar-title class="toolbar-title-3">RI Headers</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn class="mx-2" fab dark small color="primary" v-on="on" v-if="!queryMode" @click.prevent="doAdd" :loading="loading">
                              <v-icon dark>mdi-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Add RI Header</span>
                        </v-tooltip>
                      </v-toolbar>
                      <v-card-text>
                        <v-data-table
                          v-bind:headers="riHeaderColumns"
                          v-bind:items="riHeaderItems"
                          :server-items-length="totalItemsRI"
                          :footer-props="{ 'items-per-page-options': itemsPerPage }"
                          v-bind:options.sync="paginationRI"
                          item-key="key"
                          :loading="loading"
                          :no-data-text="noDataText"
                        >
                          <template v-slot:item="row">
                            <tr
                              :class="{
                                activeRow: selectedRecord == row.item.polNo + '-' + row.item.riType + '-' + row.item.riCo + '-' + row.item.acctNoSfx + '-' + row.item.cesEndtCnt
                              }"
                              @dblclick="doEdit(row.item)"
                            >
                              <td class="text-xs-left">{{ row.item.polNo }} - {{ row.item.renCnt }}/{{ row.item.endtCnt }}</td>
                              <td class="text-xs-left">{{ getRIType(row.item.riType).label }}</td>
                              <td class="text-xs-left">{{ row.item.riType === 'D' ? 'STAT' : row.item.riCoDesc }}</td>
                              <td class="text-xs-left">{{ row.item.cesEndtCnt }}</td>
                              <td class="text-xs-left">{{ row.item.acctNoSfxWithDesc }}</td>
                              <td class="text-xs-left">{{ row.item.comDateDisp }}</td>
                              <td class="text-xs-left">{{ row.item.expDateDisp }}</td>
                              <td class="table-action-header">
                                <table-action
                                  v-if="!queryMode && listMode === 'Endorsement'"
                                  :rowData="row"
                                  :review="canReview(row.item)"
                                  @review="doEdit(row.item)"
                                  :remove="canRemove(row.item)"
                                  @remove="doPromptRemove(row.item)"
                                  :custom="canEndorse(row.item)"
                                  customIcon="mdi-content-copy"
                                  customText="Endorse"
                                  @custom="doEndorse(row.item)"
                                  :query="canQuery(row.item)"
                                  @query="doQuery(row.item)"
                                ></table-action>
                                <table-action
                                  v-else-if="!queryMode"
                                  :rowData="row"
                                  :review="canReview(row.item)"
                                  @review="doEdit(row.item)"
                                  :remove="canRemove(row.item)"
                                  @remove="doPromptRemove(row.item)"
                                  :query="canQuery(row.item)"
                                  @query="doQuery(row.item)"
                                ></table-action>
                                <table-action v-else-if="queryMode" :rowData="row" query @query="doEdit(row.item)"></table-action>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                    <v-spacer class="mt-2"></v-spacer>
                    <!-- RI Header -->
                    <v-card>
                      <v-toolbar dense color="grey lighten-5" flat>
                        <div class="v-icon mdi mdi-leaf theme--light d-flex">
                          <span class="headerTitleToolbar" v-if="newRiHeader"
                            >{{ riHeaderDisplay }} RI Header
                            <span class="caption grey--text font-weight-light">(New)</span>
                          </span>
                          <span class="headerTitleToolbar" v-else-if="queryMode || isReleased"
                            >{{ riHeaderDisplay }} RI Header
                            <span class="caption grey--text font-weight-light">(Query)</span>
                          </span>
                          <span class="headerTitleToolbar" v-else
                            >{{ riHeaderDisplay }} RI Header
                            <span class="caption grey--text font-weight-light">(Review)</span>
                          </span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="showRiHeader = !showRiHeader">
                          <v-icon primary v-if="showRiHeader">mdi-chevron-down</v-icon>
                          <v-icon primary v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text v-if="showRiHeader">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.riType }}</v-subheader>
                                  <div class="queryValue">{{ riDetailInfo.riTypeDesc  }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-autocomplete
                                    @input="checkRiType"
                                    v-model="riForm.riType"
                                    v-validate="'required'"
                                    :items="riTypeList"
                                    :label="labels.riType"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="riType"
                                    :error-messages="errors.collect('riType')"
                                    :data-vv-as="labels.riType"
                                    :disabled="!newRiHeader"
                                    @change="contractCertaintyDisplayChanged"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs6 md6 lg8>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="mx-2" fab dark small color="purple" v-on="on" @click.prevent="openRiAppTxt">
                                        <v-icon dark>mdi-note-text</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>RI Application Text</span>
                                  </v-tooltip>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.riCo }}</v-subheader>
                                  <div class="queryValue">{{ riForm.riCoWithDesc }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    :disabled="riForm.riType === undefined || !newRiHeader"
                                    v-model="riForm.riCoWithDesc"
                                    v-validate="'required'"
                                    :label="labels.riCo"
                                    data-vv-name="riCo"
                                    :data-vv-as="labels.riCo"
                                    :error-messages="errors.collect('riCo')"
                                    readonly
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon v-if="riForm.riType !== undefined" color="info" @click="doShowRiCo">mdi-magnify</v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-autocomplete
                                    v-model="riForm.propXl"
                                    v-validate="'required'"
                                    :items="proplXolList"
                                    :label="labels.propXl"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="propXl"
                                    :error-messages="errors.collect('propXl')"
                                    :data-vv-as="labels.propXl"
                                    :readonly="queryMode"
                                    :disabled="queryMode || isReleased"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                                  <div class="queryValue">{{ riForm.acctNoSfxWithDesc }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    :disabled="
                                      riForm.riType === 'D' ||
                                        riForm.riType === 'T' ||
                                        riForm.riType === 'W' ||
                                        riForm.riType === undefined ||
                                        !newRiHeader
                                    "
                                    v-model="riForm.acctNoSfxWithDesc"
                                    v-validate="'required'"
                                    :label="labels.acctNoSfx"
                                    data-vv-name="acctNoSfx"
                                    :data-vv-as="labels.acctNoSfx"
                                    :error-messages="errors.collect('acctNoSfx')"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon
                                        v-if="riForm.riType === 'F' || riForm.riType === 'C'"
                                        @click="doShowAcctNoSfx"
                                        color="info"
                                      >mdi-magnify</v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.theirPolNo }}</v-subheader>
                                  <div class="queryValue">{{ riForm.theirPolNo }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.theirPolNo"
                                    :label="labels.theirPolNo"
                                    :data-vv-as="labels.theirPolNo"
                                    v-validate="'entry'"
                                    data-vv-name="theirPolNo"
                                    :error-messages="errors.collect('theirPolNo')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.cesNo }}</v-subheader>
                                  <div class="queryValue">{{ riForm.cesNo }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.cesNo"
                                    :label="labels.cesNo"
                                    :data-vv-as="labels.cesNo"
                                    v-validate="'entry'"
                                    data-vv-name="cesNo"
                                    :error-messages="errors.collect('cesNo')"
                                    :disabled="!newRiHeader"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.cesYr }}</v-subheader>
                                  <div class="queryValue">{{ riForm.cesYr }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.cesYr"
                                    :label="labels.cesYr"
                                    :data-vv-as="labels.cesYr"
                                    v-validate="'entry'"
                                    data-vv-name="cesYr"
                                    :error-messages="errors.collect('cesYr')"
                                    :disabled="!newRiHeader || newRiHeader"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-checkbox
                                    left
                                    color="primary"
                                    v-model="riForm.bordEreAux"
                                    :label="labels.bordEreAux"
                                    @change="bordEreAuxChanged"
                                    :disabled="queryMode || isReleased"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-checkbox
                                    left
                                    color="primary"
                                    v-model="riForm.prtRiApp"
                                    :label="labels.prtRiApp"
                                    :disabled="queryMode || isReleased"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-checkbox left color="primary" v-model="riForm.relRi" :label="labels.relRi"></v-checkbox>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <cal-picker
                                    v-model="riForm.tranDate"
                                    v-validate="tranDateValidation"
                                    :label="labels.tranDate"
                                    :data-vv-as="labels.tranDate"
                                    data-vv-name="tranDate"
                                    :error-messages="errors.collect('tranDate')"
                                    @change="checkTranDate"
                                    :disabled="queryMode || isReleased"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6 lg4>
                                  <cal-picker
                                    v-model="riForm.riComDate"
                                    v-validate="comDateValidation"
                                    :label="labels.riComDate"
                                    :data-vv-as="labels.riComDate"
                                    data-vv-name="riComDate"
                                    :error-messages="errors.collect('riComDate')"
                                    :disabled="!newRiHeader"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6 lg4>
                                  <cal-picker
                                    v-model="riForm.riExpDate"
                                    v-validate="expDateValidation"
                                    :label="labels.riExpDate"
                                    :data-vv-as="labels.riExpDate"
                                    data-vv-name="riExpDate"
                                    :error-messages="errors.collect('riExpDate')"
                                    :disabled="!newRiHeader"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6 lg4 v-if="!newRiHeader&&riForm.cesEndtCnt > 0">
                                  <cal-picker
                                    v-model="riForm.riEndtDate"
                                    v-validate="riForm.cesEndtCnt === 0 ? endtDateValidation : 'required'"
                                    :label="labels.riEndtDate"
                                    :data-vv-as="labels.riEndtDate"
                                    data-vv-name="riEndtDate"
                                    :error-messages="errors.collect('riEndtDate')"
                                    :disabled="queryMode || isReleased"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs12 md6 lg8 v-if="!newRiHeader&&riForm.cesEndtCnt > 0">
                                  <!-- do not remove this v-flex, for flex item adjustment -->
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-layout row wrap>
                                    <v-flex lg1>
                                      <v-checkbox
                                        left
                                        color="primary"
                                        v-model="riForm.comm1AE"
                                        :disabled="queryMode || isReleased"
                                        @change="doProcessCommission(riForm.comm1AE)"
                                      ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 md10 lg8 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ labels.comm1Pct }}</v-subheader>
                                      <div class="queryValue">{{ riForm.comm1Pct }}</div>
                                    </v-flex>
                                    <v-flex lg8 v-else>
                                      <v-text-field
                                        v-model="riForm.comm1Pct"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                        :label="labels.comm1Pct"
                                        :data-vv-as="labels.comm1Pct"
                                        v-validate="'required'"
                                        data-vv-name="comm1Pct"
                                        :error-messages="errors.collect('comm1Pct')"
                                        :disabled="riForm.comm1AE"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-layout row wrap>
                                    <v-flex xs2 md1 lg1>
                                      <v-checkbox
                                        left
                                        color="primary"
                                        v-model="riForm.comm2AE"
                                        :disabled="queryMode || isReleased"
                                        @change="doProcessCommission(riForm.comm2AE)"
                                      ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs5 md6 lg6 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ labels.comm2Pct }}</v-subheader>
                                      <div class="queryValue">{{ riForm.comm2Pct }}</div>
                                    </v-flex>
                                    <v-flex xs5 md6 lg6 v-else>
                                      <v-text-field
                                        v-model="riForm.comm2Pct"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                        :label="labels.comm2Pct"
                                        :data-vv-as="labels.comm2Pct"
                                        v-validate="'required'"
                                        data-vv-name="comm2Pct"
                                        :error-messages="errors.collect('comm2Pct')"
                                        :disabled="riForm.comm2AE"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 md5 lg5>
                                      <v-autocomplete
                                        v-model="riForm.comm2Gn"
                                        v-validate="'required'"
                                        :items="grossNetList"
                                        :label="labels.comm2Gn"
                                        item-text="label"
                                        item-value="value"
                                        data-vv-name="comm2Gn"
                                        :error-messages="errors.collect('comm2Gn')"
                                        :data-vv-as="labels.comm2Gn"
                                        :disabled="queryMode || isReleased"
                                      ></v-autocomplete>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg4>
                                  <v-layout row wrap>
                                    <v-flex xs2 md1 lg1>
                                      <v-checkbox
                                        left
                                        color="primary"
                                        v-model="riForm.comm3AE"
                                        :disabled="queryMode || isReleased"
                                        @change="doProcessCommission(riForm.comm3AE)"
                                      ></v-checkbox>
                                    </v-flex>
                                    <v-flex xs5 md6 lg6 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ labels.comm3Pct }}</v-subheader>
                                      <div class="queryValue">{{ riForm.comm3Pct }}</div>
                                    </v-flex>
                                    <v-flex xs5 md6 lg6 v-else>
                                      <v-text-field
                                        v-model="riForm.comm3Pct"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                        :label="labels.comm3Pct"
                                        :data-vv-as="labels.comm3Pct"
                                        v-validate="'required'"
                                        data-vv-name="comm3Pct"
                                        :error-messages="errors.collect('comm3Pct')"
                                        :disabled="riForm.comm3AE"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs5 md5 lg5>
                                      <v-autocomplete
                                        v-model="riForm.comm3Gn"
                                        v-validate="'required'"
                                        :items="grossNetList"
                                        :label="labels.comm3Gn"
                                        item-text="label"
                                        item-value="value"
                                        data-vv-name="comm3Gn"
                                        :error-messages="errors.collect('comm3Gn')"
                                        :data-vv-as="labels.comm3Gn"
                                        :disabled="queryMode || isReleased"
                                      ></v-autocomplete>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.stampDuty }}</v-subheader>
                                  <div class="queryValue">{{ riForm.stampDuty }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.stampDuty"
                                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                    :label="labels.stampDuty"
                                    :data-vv-as="labels.stampDuty"
                                    v-validate="'entry'"
                                    data-vv-name="stampDuty"
                                    :error-messages="errors.collect('stampDuty')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.riTax }}</v-subheader>
                                  <div class="queryValue">{{ riForm.riTax }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.riTax"
                                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                    :label="labels.riTax"
                                    :data-vv-as="labels.riTax"
                                    v-validate="'entry'"
                                    data-vv-name="riTax"
                                    :error-messages="errors.collect('riTax')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.riLevy }}</v-subheader>
                                  <div class="queryValue">{{ riForm.riLevy }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else>
                                  <v-text-field
                                    v-model="riForm.riLevy"
                                    v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                    :label="labels.riLevy"
                                    :data-vv-as="labels.riLevy"
                                    v-validate="'entry'"
                                    data-vv-name="riLevy"
                                    :error-messages="errors.collect('riLevy')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md6 lg4 v-show="!newRiHeader">
                                  <cal-picker
                                    v-model="riForm.relDate"
                                    :label="labels.relDate"
                                    :data-vv-as="labels.relDate"
                                    data-vv-name="relDate"
                                    :error-messages="errors.collect('relDate')"
                                    :disabled="!newRiHeader"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                  <v-subheader class="queryLabel">{{ labels.relUsr }}</v-subheader>
                                  <div class="queryValue">{{ riForm.relUsr }}</div>
                                </v-flex>
                                <v-flex xs6 md6 lg4 v-else v-show="!newRiHeader">
                                  <v-text-field
                                    v-model="riForm.relUsr"
                                    :label="labels.relUsr"
                                    :data-vv-as="labels.relUsr"
                                    v-validate="'entry'"
                                    data-vv-name="relUsr"
                                    :error-messages="errors.collect('relUsr')"
                                    :disabled="!newRiHeader"
                                  ></v-text-field>
                                </v-flex>
                                <transition name="slide-y-transition" mode="out-in">
                                  <v-flex xs12 v-if="checkContractCertaintyDisplay">
                                    <v-card>
                                      <v-toolbar dense color="grey lighten-5" flat>
                                        <v-icon>mdi-format-align-justify</v-icon>
                                        <v-toolbar-title class="toolbar-title-3">Contract Certainty</v-toolbar-title>
                                      </v-toolbar>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                            <v-subheader class="queryLabel">{{ labels.ccaDate }}</v-subheader>
                                            <div class="queryValue">{{ formatDate(riForm.ccaDate) }}</div>
                                          </v-flex>
                                          <v-flex xs6 md6 lg4 v-else>
                                            <cal-picker
                                              v-model="riForm.ccaDate"
                                              :label="labels.ccaDate"
                                              :data-vv-as="labels.ccaDate"
                                              data-vv-name="ccaDate"
                                              :disabled="queryMode || isReleased"
                                              :error-messages="errors.collect('ccaDate')"
                                            />
                                          </v-flex>
                                          <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                            <v-subheader class="queryLabel">{{ labels.ccdDate }}</v-subheader>
                                            <div class="queryValue">{{ formatDate(riForm.ccdDate) }}</div>
                                          </v-flex>
                                          <v-flex xs6 md6 lg4 v-else>
                                            <cal-picker
                                              v-model="riForm.ccdDate"
                                              :label="labels.ccdDate"
                                              :data-vv-as="labels.ccdDate"
                                              data-vv-name="ccdDate"
                                              :disabled="queryMode"
                                              :error-messages="errors.collect('ccdDate')"
                                            />
                                          </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                          <v-flex xs6 md6 lg4 v-if="riForm.ccDateEntUsr">
                                            <v-subheader class="queryLabel">{{ labels.ccDateEntUsr }}</v-subheader>
                                            <div class="queryValue">{{ riForm.ccDateEntUsr }}</div>
                                          </v-flex>
                                          <v-flex xs6 md6 lg4 v-if="riForm.ccDateRevUsr">
                                            <v-subheader class="queryLabel">{{ labels.ccDateRevUsr }}</v-subheader>
                                            <div class="queryValue">{{ riForm.ccDateRevUsr }}</div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                    </v-card>
                                  </v-flex>
                                </transition>
                              </v-layout>
                            </v-container>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions v-if="showRiHeader">
                        <v-spacer></v-spacer>
                        <v-btn depressed text @click.native="doCancel" :loading="loading"> <span class="btn-normal-error">Cancel</span></v-btn>
                        <v-btn depressed v-show="!queryMode && !isReleased" text @click.native="doSaveRiHeader" :loading="loading">
                          <span class="btn-normal-primary">Save</span></v-btn
                        >
                      </v-card-actions>
                    </v-card>
                    <v-spacer class="mt-1"></v-spacer>
                    <!-- RI Details -->
                    <v-card v-if="!disableRiOutRiskPrem">
                      <v-toolbar dense color="grey lighten-5" flat>
                        <div class="v-icon mdi mdi-format-list-bulleted theme--light d-flex">
                          <span class="headerTitleToolbar">{{ riHeaderDisplay }} RI Details</span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="showRiDetails = !showRiDetails">
                          <v-icon primary v-if="showRiDetails">mdi-chevron-down</v-icon>
                          <v-icon primary v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text v-if="showRiDetails">
                        <v-data-table
                          v-bind:headers="listRIDetails"
                          v-bind:items="riDetailItems"
                          :server-items-length="totalItemsRiDetail"
                          :footer-props="{ 'items-per-page-options': itemsPerPage }"
                          v-bind:options.sync="paginationRiDetail"
                          item-key="key"
                          :loading="loading"
                          :no-data-text="noDataText"
                        >
                          <template v-slot:item="row"
                            ><tr>
                              <td v-for="column in selectedRIDetailColumns" :key="column">
                                {{ column === 'riSI' || column === 'riNetPremDisp' ? formatMoney(row.item[column]) : (column === 'riskNo' ? row.item['riskGrpNo'].toString().padStart(2, '0') + '/' + row.item[column].toString().padStart(3, '0') : row.item[column] )  }}
                              </td>
                              <td class="table-action-custom">
                                <table-action
                                  v-if="!queryMode && !isReleased"
                                  :rowData="row"
                                  review
                                  @review="doReviewDetails(row.item)"
                                ></table-action>
                                <table-action v-if="queryMode || isReleased" :rowData="row" query @query="doReviewDetails(row.item)"></table-action>
                              </td>
                            </tr>
                            <div class="mt-2"></div>
                          </template>
                          <template v-slot:footer>
                            <v-simple-table>
                              <tbody>
                                <tr>
                                  <td style="width: 95px"></td>
                                  <td style="width: 95px"></td>
                                  <td class="text-right" style="width: 95px">
                                    <strong>Total:</strong>
                                  </td>
                                  <td style="width: 95px">{{ getRIPremiumTotal }}</td>
                                  <td style="width: 95px">{{ getRIComm1Total }}</td>
                                  <td style="width: 95px">{{ getRIComm2Total }}</td>
                                  <td style="width: 95px">{{ getRIComm3Total }}</td>
                                  <td style="width: 95px">{{ getRINetPremTotal }}</td>
                                  <td style="width: 95px">{{ getRILevyTotal }}</td>
                                  <td style="width: 95px">{{ getRITaxTotal }}</td>
                                  <td style="width: 89px"></td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                    <v-spacer class="mt-1"></v-spacer>
                    <v-card id="riDetailFormCard" v-if="!disableRiOutRiskPrem">
                      <v-toolbar dense color="grey lighten-5" flat>
                        <div class="v-icon mdi mdi-format-align-justify theme--light d-flex">
                          <span class="headerTitleToolbar"
                            >{{ riHeaderDisplay }} RI Details for
                            <span class="caption grey--text font-weight-light">({{ riDetailLabels.riskDesc }}: {{ riDetailForm.riskDesc }})</span>
                          </span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="showRiDetailsForm = !showRiDetailsForm">
                          <v-icon primary v-if="showRiDetailsForm">mdi-chevron-down</v-icon>
                          <v-icon primary v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text v-if="showRiDetailsForm">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-container>
                              <v-layout row wrap>
                                <v-flex xs6 md6 lg6>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riSIPct }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riSIPct }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riSIPctAE" @change="recalculate"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        ref="riSIPct"
                                        v-model="riDetailForm.riSIPct"
                                        :label="riDetailLabels.riSIPct"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                        @blur="recalculate"
                                        data-vv-name="riSIPct"
                                        :data-vv-as="riDetailLabels.riSIPct"
                                        :error-messages="errors.collect('riSIPct')"
                                        type="tel"
                                        v-validate="'required|mask_decimal:6|mask_min_value:0|mask_max_value:100'"
                                        :disabled="riDetailForm.riSIPctAE"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riSI }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riSI }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riSIAE" @change="recalculate" />
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riSI"
                                        :label="riDetailLabels.riSI"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riSI"
                                        data-vv-name="riSI"
                                        @change="recalculate"
                                        :error-messages="errors.collect('riSI')"
                                        :disabled="riDetailForm.riSIAE"
                                        type="tel"
                                        v-validate="'required|mask_decimal:2'"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riPrem }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riPrem }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riPremAE" @change="recalculate"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riPrem"
                                        :label="riDetailLabels.riPrem"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riPrem"
                                        @change="recalculate"
                                        v-validate="'entry'"
                                        data-vv-name="riPrem"
                                        :error-messages="errors.collect('riPrem')"
                                        :disabled="riDetailForm.riPremAE"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.prtyLim }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.prtyLim }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1></v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.prtyLim"
                                        :label="riDetailLabels.prtyLim"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.prtyLim"
                                        v-validate="'entry'"
                                        data-vv-name="prtyLim"
                                        :error-messages="errors.collect('prtyLim')"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6 order-lg1 order-md1>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riComm1 }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riComm1 }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riComm1AE" @change="recalculate"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riComm1"
                                        :label="riDetailLabels.riComm1"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riComm1"
                                        v-validate="'entry'"
                                        @change="recalculate"
                                        data-vv-name="riComm1"
                                        :error-messages="errors.collect('riComm1')"
                                        :disabled="riDetailForm.riComm1AE"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6 order-lg3 order-md3>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riComm2 }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riComm2 }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riComm2AE" @change="recalculate"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riComm2"
                                        :label="riDetailLabels.riComm2"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riComm2"
                                        v-validate="'entry'"
                                        @change="recalculate"
                                        data-vv-name="riComm2"
                                        :error-messages="errors.collect('riComm2')"
                                        :disabled="riDetailForm.riComm2AE"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6 order-lg5 order-md5>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riComm3 }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riComm3 }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riComm3AE" @change="recalculate"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riComm3"
                                        :label="riDetailLabels.riComm3"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riComm3"
                                        @change="recalculate"
                                        v-validate="'entry'"
                                        data-vv-name="riComm3"
                                        :error-messages="errors.collect('riComm3')"
                                        :disabled="riDetailForm.riComm3AE"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6 order-lg2 order-md2>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riLevy }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riLevy }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riLevyAE"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riLevy"
                                        :label="riDetailLabels.riLevy"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riLevy"
                                        v-validate="'entry'"
                                        data-vv-name="riLevy"
                                        :error-messages="errors.collect('riLevy')"
                                        :disabled="riDetailForm.riLevyAE"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 md6 lg6 order-lg4 order-md4>
                                  <v-layout v-if="queryMode || isReleased">
                                    <v-flex xs6 md6 lg4 v-if="queryMode || isReleased">
                                      <v-subheader class="queryLabel">{{ riDetailLabels.riTax }}</v-subheader>
                                      <div class="queryValue">{{ riDetailForm.riTax }}</div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout v-else>
                                    <v-flex xs1 md1 lg1>
                                      <v-checkbox left color="primary" v-model="riDetailForm.riTaxAE"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs10 md10 lg10>
                                      <v-text-field
                                        v-model="riDetailForm.riTax"
                                        :label="riDetailLabels.riTax"
                                        v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                                        :data-vv-as="riDetailLabels.riTax"
                                        v-validate="'entry'"
                                        data-vv-name="riTax"
                                        :error-messages="errors.collect('riTax')"
                                        :disabled="riDetailForm.riTaxAE"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions v-if="showRiDetailsForm">
                        <v-spacer></v-spacer>
                        <v-btn depressed text @click.native="doCancelDetail" :loading="loading"> <span class="btn-normal-error">Cancel</span></v-btn>
                        <v-btn depressed v-show="!queryMode && !isReleased" text @click.native="doSaveRiDetail" :loading="loading">
                          <span class="btn-normal-primary">Save</span></v-btn
                        >
                      </v-card-actions>
                    </v-card>
                    <v-spacer class="mt-1"></v-spacer>
                    <!-- RI Out Bordereaux Start -->
                    <v-card v-if="showRiOutBord">
                      <v-toolbar dense color="grey lighten-5" text>
                        <v-icon>mdi-format-align-justify</v-icon>
                        <v-toolbar-title class="toolbar-title-2">Bordereaux Item Details</v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-flex xs12 class="mt-3" v-if="messages.length > 0">
                            <message :messages="messages"></message>
                          </v-flex>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-data-table
                                v-bind:headers="listRIOutBord"
                                v-bind:items="riOutBordItems"
                                :server-items-length="totalItemsRiOutBord"
                                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                                v-bind:options.sync="paginationRiOutBord"
                                item-key="itemNo"
                                :loading="loading"
                                :no-data-text="noDataText"
                              >
                                <template v-slot:item="row">
                                  <tr
                                    :class="{ activeRowRiOutBord: selectedRiOutBordRecord == parseInt(row.item.itemNo) }"
                                    @dblclick="doEditRiOutBord(row.item)"
                                  >
                                    <td v-for="column in selectedRIOutBordColumns" :key="column">
                                      {{ row.item[column] }}
                                    </td>
                                    <td class="table-action-header">
                                      <table-action
                                        :rowData="row"
                                        review
                                        @review="doEditRiOutBord(row.item)"
                                        remove
                                        @remove="doPromptRemoveRiOutBord(row.item)"
                                        query
                                        @query="doQueryRiOutBord(row.item)"
                                      ></table-action>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                          <!--Start Delete Prompt -->
                          <confirm v-model="promptRemoveRiOutBord" @ok="doDeleteRiOutBord">
                            <p>{{ labels.promptRemoveRiOutBord }}</p>
                            <div class="queryValue">{{ deleteRiOutBord }}</div>
                          </confirm>
                          <!-- End Delete Prompt-->
                        </v-container>
                      </v-card-text>
                    </v-card>
                    <v-spacer class="mt-1"></v-spacer>
                    <v-card id="riFormCard" v-if="showRiOutBord && disableRiOutRiskPrem">
                      <v-toolbar dense color="grey lighten-5" flat>
                        <div class="v-icon mdi mdi-leaf theme--light d-flex">
                          <span class="headerTitle-b" v-if="newRiOutBord"
                            >RI Bordereaux
                            <span class="caption grey--text font-weight-light">(New)</span>
                          </span>
                          <span class="headerTitle-b" v-else-if="queryMode || isReleased"
                            >RI Bordereaux
                            <span class="caption grey--text font-weight-light">(Query)</span>
                          </span>
                          <span class="headerTitle-b" v-else
                            >RI Bordereaux
                            <span class="caption grey--text font-weight-light">(Review)</span>
                          </span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn icon @click.native="showRiOutBordDetails = !showRiOutBordDetails">
                          <v-icon primary v-if="showRiOutBordDetails">mdi-chevron-down</v-icon>
                          <v-icon primary v-else>mdi-chevron-up</v-icon>
                        </v-btn>
                      </v-toolbar>
                      <v-card-text v-if="showRiOutBordDetails">
                        <v-layout row wrap>
                          <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                            <v-text-field
                              v-model="riForm.riTypeCo"
                              :label="labels.riTypeCo"
                              :data-vv-as="labels.riTypeCo"
                              v-validate="'entry'"
                              data-vv-name="riTypeCo"
                              :error-messages="errors.collect('riTypeCo')"
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-subheader class="queryLabel">{{ labels.riTypeCo }}</v-subheader>
                            <div class="queryValue">{{ riForm.riTypeCo }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4>
                            <cal-picker
                              v-model="riForm.riComDate"
                              :label="labels.riComDate"
                              :data-vv-as="labels.riComDate"
                              data-vv-name="riComDate"
                              :error-messages="errors.collect('riComDate')"
                              :disabled="true"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs6 md6 lg4>
                            <cal-picker
                              v-model="riForm.riExpDate"
                              :label="labels.riExpDate"
                              :data-vv-as="labels.riExpDate"
                              data-vv-name="riExpDate"
                              :error-messages="errors.collect('riExpDate')"
                              :disabled="true"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                            <v-autocomplete
                              :items="bordItemList"
                              v-model="riForm.itemNo"
                              :label="labels.itemNo"
                              item-text="label"
                              item-value="value"
                              data-vv-name="itemNo"
                              :data-vv-as="labels.itemNo"
                              :error-messages="errors.collect('itemNo')"
                              clearable
                              v-validate="'required'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
                            <div class="queryValue">{{ riForm.itemNo }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                            <v-text-field
                              v-model="riForm.cedPolNo"
                              :label="labels.cedPolNo"
                              :data-vv-as="labels.cedPolNo"
                              v-validate="'entry'"
                              data-vv-name="cedPolNo"
                              :error-messages="errors.collect('cedPolNo')"
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                            <div class="queryValue">{{ riForm.cedPolNo }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4></v-flex>
                          <v-flex xs1 md1 lg1>
                            <v-checkbox
                              class="align-end justify-end"
                              primary
                              hide-details
                              v-model="riForm.riSIAE"
                              :disabled="queryRiOutBord"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riSI"
                              :label="labels.riSI"
                              :data-vv-as="labels.riSI"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              data-vv-name="riSI"
                              :error-messages="errors.collect('riSI')"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-else>
                            <v-subheader class="queryLabel">{{ labels.riSI }}</v-subheader>
                            <div class="queryValue">{{ riForm.riSI }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riSIPct"
                              :label="labels.riSIPct"
                              :data-vv-as="labels.riSIPct"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                              data-vv-name="riSIPct"
                              :error-messages="errors.collect('riSIPct')"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-subheader class="queryLabel">{{ labels.riSIPct }}</v-subheader>
                            <div class="queryValue">{{ riForm.riSIPct }}</div>
                          </v-flex>
                          <v-flex xs1 md1 lg1>
                            <v-checkbox
                              class="align-end justify-end"
                              primary
                              hide-details
                              v-model="riForm.riPremAE"
                              :disabled="queryRiOutBord"
                              @change="recalculateRIOutBord"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riPrem"
                              :label="labels.riPrem"
                              :data-vv-as="labels.riPrem"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              data-vv-name="riPrem"
                              :error-messages="errors.collect('riPrem')"
                              :disabled="disableRiPrem"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-else>
                            <v-subheader class="queryLabel">{{ labels.riPrem }}</v-subheader>
                            <div class="queryValue">{{ riForm.riPrem }}</div>
                          </v-flex>
                          <v-flex xs1 md1 lg1>
                            <v-checkbox
                              class="align-end justify-end"
                              primary
                              hide-details
                              v-model="riForm.riComm1AE"
                              :disabled="queryRiOutBord"
                              @change="recalculateRIOutBord"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riComm1"
                              :label="labels.riComm1"
                              :data-vv-as="labels.riComm1"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              data-vv-name="riComm1"
                              :error-messages="errors.collect('riComm1')"
                              :disabled="disableRiComm1"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-else>
                            <v-subheader class="queryLabel">{{ labels.riComm1 }}</v-subheader>
                            <div class="queryValue">{{ riForm.riComm1 }}</div>
                          </v-flex>
                          <v-flex xs1 md1 lg1>
                            <v-checkbox
                              class="align-end justify-end"
                              primary
                              hide-details
                              v-model="riForm.riComm2AE"
                              :disabled="queryRiOutBord"
                              @change="recalculateRIOutBord"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riComm2"
                              :label="labels.riComm2"
                              :data-vv-as="labels.riComm2"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              data-vv-name="riComm2"
                              :error-messages="errors.collect('riComm2')"
                              :disabled="disableRiComm2"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-else>
                            <v-subheader class="queryLabel">{{ labels.riComm2 }}</v-subheader>
                            <div class="queryValue">{{ riForm.riComm2 }}</div>
                          </v-flex>
                          <v-flex xs1 md1 lg1>
                            <v-checkbox
                              class="align-end justify-end"
                              primary
                              hide-details
                              v-model="riForm.riComm3AE"
                              :disabled="queryRiOutBord"
                              @change="recalculateRIOutBord"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                            <v-text-field
                              v-model="riForm.riComm3"
                              :label="labels.riComm3"
                              :data-vv-as="labels.riComm3"
                              v-validate="'entry'"
                              v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                              data-vv-name="riComm3"
                              :error-messages="errors.collect('riComm3')"
                              :disabled="disableRiComm3"
                              @blur="recalculateRIOutBord"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs5 md5 lg3 v-else>
                            <v-subheader class="queryLabel">{{ labels.riComm3 }}</v-subheader>
                            <div class="queryValue">{{ riForm.riComm3 }}</div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions v-if="!queryRiOutBord && showRiOutBordDetails">
                        <v-spacer></v-spacer>
                        <v-btn depressed text @click.native="doAddRiOutBord = false" :loading="loading">
                          <span class="btn-normal-error">Cancel</span></v-btn
                        >
                        <v-btn depressed v-show="!queryMode" text @click.native="doSaveRiOutBord" :loading="loading">
                          <span class="btn-normal-primary">Save</span></v-btn
                        >
                      </v-card-actions>
                    </v-card>
                    <!-- RI Out Bordereaux END -->
                  </v-flex>
                  <v-card-actions>
                    <v-btn color="error" dark @click.native="doBack">
                      <span>Exit</span>
                      <v-icon dark right>mdi-exit-to-app</v-icon>
                    </v-btn>
                    <v-btn dark color="primary" @click="doPromptRelease" :disabled="disableRelease || isReleased">
                      <span v-if="this.riTranRel">Released</span>
                      <span v-else>Release RI</span>
                      <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="riCoDialog" width="1280px">
        <v-card>
          <v-card-title class="secondary lighten-4">
            <span class="headline">Select Company</span>
            <v-spacer></v-spacer>
            <v-btn text icon @click="doClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                data-vv-scope="inter"
                                v-model="filters.inter"
                                :label="labels.inter"
                                :error-messages="errors.collect('inter')"
                                data-vv-name="inter"
                                :data-vv-as="labels.inter"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-flex xs12>
                            <v-text-field
                              data-vv-scope="name"
                              v-model="filters.name"
                              :label="labels.name"
                              :error-messages="errors.collect('name')"
                              data-vv-name="name"
                              :data-vv-as="labels.name"
                            ></v-text-field>
                          </v-flex>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearInterFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doInterFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-data-table
                class="elevation-1"
                v-bind:headers="listRICo"
                v-bind:items="riCoItems"
                :server-items-length="totalItemsRiCo"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="paginationRiCo"
                item-key="x"
                :loading="loading"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td>{{ row.item.inter }}</td>
                    <td>{{ row.item.name }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" copy @copy="doSelectRiCo(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="riTreatyDialog" width="1280px">
        <v-card>
          <v-card-title class="secondary lighten-4">
            <span class="headline">Select Treaty</span>
            <v-spacer></v-spacer>
            <v-btn text icon @click="doClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                data-vv-scope="ttyNo"
                                v-model="filters.ttyNo"
                                :label="labels.ttyNo"
                                :error-messages="errors.collect('ttyNo')"
                                data-vv-name="ttyNo"
                                :data-vv-as="labels.ttyNo"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-flex xs12>
                            <v-text-field
                              data-vv-scope="ttyDesc"
                              v-model="filters.ttyDesc"
                              :label="labels.ttyDesc"
                              :error-messages="errors.collect('ttyDesc')"
                              data-vv-name="ttyDesc"
                              :data-vv-as="labels.ttyDesc"
                            ></v-text-field>
                          </v-flex>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearRiTreatyFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doRiTreatyFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-data-table
                class="elevation-1"
                v-bind:headers="listRITreaty"
                v-bind:items="riTreatyItems"
                :server-items-length="totalItemsRiTreaty"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="paginationRiTreaty"
                item-key="x"
                :loading="loading"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td>{{ row.item.ttyNo }}</td>
                    <td>{{ row.item.ttyDesc }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" copy @copy="doSelectRiTreaty(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="riAcctNoSfxDialog" width="1280px">
        <v-card>
          <v-card-title class="secondary lighten-4">
            <span class="headline">Select Account No. Suffix</span>
            <v-spacer></v-spacer>
            <v-btn text icon @click="doClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                                data-vv-scope="acctNoSfx"
                                v-model="filters.acctNoSfx"
                                :label="labels.acctNoSfx"
                                :error-messages="errors.collect('acctNoSfx')"
                                data-vv-name="acctNoSfx"
                                :data-vv-as="labels.acctNoSfx"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearAcctNoSfxFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doAcctNoSfxFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
            <v-flex xs12 class="mt-2">
              <v-data-table
                class="elevation-1"
                v-bind:headers="listRIAcctNoSfx"
                v-bind:items="riAcctNoSfxItems"
                :server-items-length="totalItemsRiAcctNoSfx"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="paginationRiAcctNoSfx"
                item-key="x"
                :loading="loading"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td>{{ row.item.acctNoSfx }}</td>
                    <td>{{ row.item.acctNoSfxDesc }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" copy @copy="doSelectRiAcctNoSfx(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <span class="info-dialog-msg-header">Oops something went wrong...</span>
              <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="riAppTxtDialog" width="50%" persistent>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{ labels.riAppTxt }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-tabs v-model="tabMenu">
                    <v-tab>{{ labels.riAppTxt }}</v-tab>
                    <v-tab>{{ labels.riAppEndtTxt }}</v-tab>
                    <v-tabs-items v-model="tabMenu" touchless>
                      <v-tab-item :key="0">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea
                                  v-model="riForm.riAppTxtTemp"
                                  :error-messages="errors.collect('riAppTxt')"
                                  v-validate="'max:8000|entry'"
                                  data-vv-validate-on="change"
                                  data-vv-name="riAppTxt"
                                  :data-vv-as="labels.riAppTxt"
                                  :counter="8000"
                                  :rows="20"
                                  :disabled="queryMode || isReleased"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item :key="1">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea
                                  v-model="riForm.riAppEndtTxtTemp"
                                  :error-messages="errors.collect('riAppEndtTxt')"
                                  v-validate="'max:8000|entry'"
                                  data-vv-validate-on="change"
                                  data-vv-name="riAppEndtTxt"
                                  :data-vv-as="labels.riAppEndtTxt"
                                  :counter="8000"
                                  :rows="20"
                                  :disabled="queryMode || isReleased"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click.native="riAppTxtDialog = false"><span class="btn-normal-error">Close</span></v-btn>
            <v-btn depressed @click="saveRiAppTxt" v-if="!queryMode && !isReleased"><span class="btn-normal-primary">Save</span></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <prompt-leave
        v-if="showPromptLeave"
        title="RI Header"
        :tranMode="this.tab"
        :tranType="this.mode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>
    </v-container>
    <!-- Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">{{ deleteRIHeader }}</div>
    </confirm>
    <!-- End Delete Prompt-->
    <!--Start Release Prompt -->
    <confirm v-model="promptRiRelease" @ok="doRelease">
      {{ labels.promptRelease }}
    </confirm>
    <!-- End Release Prompt -->
    <!-- Start Coinsurance Service Fee -->
    <v-dialog v-model="coinsSvcFeeDialog" width="1000px" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>Coinsurance Service Fee</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text icon @click="coinsSvcFeeDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <riCoinsuranceServiceFee
            v-if="coinsSvcFeeDialog === true"
            ref="coinsSvcFee"
            :selectedRi="selectedRi"
            :setMode="mode"
            @close="coinsSvcFeeDialog = false"
          ></riCoinsuranceServiceFee>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End Coinsurance Service Fee -->
  </page>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import riLifeCycle from '@/components/core/underwriting/reinsurance/riLifeCycle'
import { riAjaxMixin } from '@/mixins/reinsurance/riAjaxMixin'
import { riListMixin } from '@/mixins/reinsurance/riListMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { removeTime, formatDisplayDate } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { parseISO } from 'date-fns'
import { extractMenu } from '@/utils/extract'
import { formatPrice } from '@/utils/index'
import riCoinsuranceServiceFee from './riCoinsuranceServiceFee'
import clone from 'clone'

export default {
  data() {
    return {
      tabMenu: 0,
      processingFlag: false,
      selectedRecord: '',
      selectedRiOutBordRecord: '',
      selectedRow: {},
      selectedRiOutBordRow: {},
      key: 0,
      riDetailTab: true,
      lifeCycle: false,
      showRiHeader: false,
      showRiDetails: true,
      showRiDetailsForm: false,
      showErrorDialog: false,
      showPromptLeave: true,
      showRiOutBord: false,
      showRiOutBordDetails: true,
      currentDate: new Date().toISOString().substr(0, 10),
      riTabs: ['RI Header', 'RI Details'],
      labels: {
        riType: 'RI Type',
        riCo: 'RI Company / Treaty',
        propXl: 'Proportional / XOL',
        acctNoSfx: 'Account No. Suffix',
        theirPolNo: 'Their Policy No.',
        cesNo: 'Cession No.',
        cesYr: 'Cession Year',
        bordEreAux: 'Bordereaux',
        prtRiApp: 'Print RI Closing',
        relRi: 'Release Now',
        tranDate: 'Transaction Date',
        riComDate: 'Commencement Date',
        riExpDate: 'Expiry Date',
        comm1Pct: 'Commission 1 %',
        comm2Pct: 'Commission 2 %',
        comm2Gn: 'Gross/Net',
        comm3Pct: 'Commission 3 %',
        comm3Gn: 'Gross/Net',
        stampDuty: 'Stamp Duty',
        riTax: 'Tax',
        riLevy: 'RI Levy',
        ccaDate: 'Acceptance Date',
        ccdDate: 'Documentation date',
        ccDateEntUsr: 'Entered By',
        ccDateRevUsr: 'Reviewed By',
        riAppTxt: 'RI Application Text',
        riAppEndtTxt: 'RI Application Endt Text',
        promptRemove: 'Are you sure you want to delete the selected RI Header?',
        promptRemoveRiOutBord: 'Are you sure you want to delete the selected RI Bordereaux?',
        promptRelease: 'Are you sure you want to release all the unreleased RI?',
        cesEndtNo: 'Cession Endorsement No.',
        cesStamp: 'Cession Stamp',
        riEndtDate: 'Endorsement Date',
        billCurr: 'Billing Currency',
        docNo: 'Document No.',
        itemNo: 'Bordereaux Item',
        cedPolNo: 'Reference No.',
        riSI: 'Sum Insured',
        riSIPct: 'Sum Insured %',
        riPrem: 'RI Premium',
        riComm1: 'RI Comm 1',
        riComm2: 'RI Comm 2',
        riComm3: 'RI Comm 3',
        riTypeCo: 'RI Type - RI Company',
        relDate: 'Release Date',
        relUsr: 'Released By',
        miscparams: {}
      },
      filters: {
        // Company
        inter: undefined,
        name: undefined,
        // Treaty
        ttyNo: undefined,
        ttyDesc: undefined
      },
      riDetailLabels: {
        riskDesc: 'Risk Group/No.',
        riSI: 'RI Sum Insured (Amount)',
        riSIPct: 'RI Sum Insured (%)',
        riPrem: 'RI Premium',
        prtyLim: 'Priority Limit',
        riComm1: 'RI Commission 1',
        riComm2: 'RI Commission 2',
        riComm3: 'RI Commission 3',
        riLevy: 'RI Levy',
        riTax: 'RI Tax'
      },
      riForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        billCurr: undefined,
        billCurrRate: undefined,
        dept: undefined,
        cesEndtCnt: 0,
        riType: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        propXl: 'P',
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        theirPolNo: undefined,
        cesNo: undefined,
        cesYr: 0,
        bordEreAux: false,
        prtRiApp: false,
        relRi: true,
        tranDate: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        comm1AE: undefined,
        comm1Pct: 0,
        comm2AE: false,
        comm2Pct: 0,
        comm2Gn: 'G',
        comm3AE: false,
        comm3Pct: 0,
        comm3Gn: 'G',
        stampDuty: 0,
        riTax: 0,
        riLevy: 0,
        actionName: 0,
        ccaDate: undefined,
        ccdDate: undefined,
        ccDateEntUsr: undefined,
        ccDateRevUsr: undefined,
        riAppTxt: undefined,
        riAppEndtTxt: undefined,
        riAppTxtTemp: undefined,
        riAppEndtTxtTemp: undefined,
        cesEndtNo: undefined,
        cesStamp: 0,
        riEndtDate: undefined,
        docNo: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        cedPolNo: undefined,
        riSIAE: false,
        riSI: 0,
        riSIPct: 0,
        riPremAE: true,
        riPrem: 0,
        riComm1AE: true,
        riComm1: 0,
        riComm2AE: true,
        riComm2: 0,
        riComm3AE: true,
        riComm3: 0,
        riTypeCo: undefined,
        addRI: false,
        acctMth: undefined,
        acctYr: undefined,
        selectedComm: '',
        tranDateValidationMessage: undefined,
        tranDateValidation: false,
        relDate: undefined,
        relUsr: undefined
      },
      riPrevCesForm: {
        polNo: undefined,
        renCnt: undefined,
        cesEndtCnt: undefined,
        riType: undefined,
        riCo: undefined,
        endtCnt: undefined,
        riEndtDate: undefined
      },
      riDetailForm: {
        polNo: undefined,
        renCnt: undefined,
        cesEndtCnt: undefined,
        riType: '',
        riCo: undefined,
        acctNoSfx: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        endtCnt: undefined,
        riskDesc: undefined,
        riSI: 0,
        riSIAE: true,
        riSIPct: undefined,
        riSIPctAE: true,
        riPrem: undefined,
        riPremAE: true,
        prtyLim: undefined,
        riComm1: 0,
        riComm1Disp: 0,
        riComm1AE: true,
        riComm2: undefined,
        riComm2AE: true,
        riComm3: undefined,
        riComm3AE: true,
        riLevy: undefined,
        riLevyAE: true,
        riTax: undefined,
        riTaxAE: true,
        actionName: 0,
        riDetailSelected: undefined,
        riPremAccum: 0,
        riSIPctAccum: 0
      },
      riDetailInfo: {
        riType: undefined,
        riTypeDesc: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        propXl: undefined,
        propXlDesc: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        riComm2Gn: undefined,
        riComm3Gn: undefined
      },
      breadcrumb: [],
      tab: 'RI Header',
      riHeaderPanel: false,
      riDetailPanel: false,
      riCoDialog: false,
      riTreatyDialog: false,
      riAcctNoSfxDialog: false,
      newRiHeader: true,
      newRiDetail: true,
      newRiOutBord: false,
      editRiOutBord: false,
      queryRiOutBord: false,
      acctnosfx: [],
      riAppTxtDialog: false,
      riClosingMenu: {},
      promptRemove: false,
      promptRemoveRiOutBord: false,
      selectedRIHeader: undefined,
      selectedRiOutBord: undefined,
      deleteRIHeader: undefined,
      deleteRiOutBord: undefined,
      checkContractCertaintyDisplay: true,
      riHeaderColumns: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Company', value: 'riCoDesc' },
        { text: 'CessEndt Count', value: 'cesEndtCnt' },
        { text: 'Account Suffix', value: 'acctNoSfxDesc' },
        { text: 'Comm Date', value: 'comDateDisp' },
        { text: 'Expiry Date', value: 'expDateDisp' },
        TableConst.tableActionHeader
      ],
      disableRiPrem: false,
      disableRiComm1: true,
      disableRiComm2: true,
      disableRiComm3: true,
      disableRiOutRiskPrem: false,
      bordItemList: [],
      coinsSvcFeeDialog: false,
      showCoinsSvcFeeBtn: false,
      tabs: [],
      acctNoSfxMapData_6: {},
      acctNoSfxMapData_5: {},
      dri_: '',
      acctNoSfxApplnInt_: 0,
      riHeaderDisplay: '',
      paginationRI: {
        page: 1
      },
      paginationRiDetail: {
        page: 1
      },
      paginationRiCo: {
        page: 1
      },
      paginationRiTreaty: {
        page: 1
      },
      isReleased: false,
      promptRiRelease: false,
      loadingFlag: false,
      defCesYr: 0,
      uwYr: undefined,
      billCurrDesc: '',
      miscparams: {}
    }
  },
  watch: {
    acctnosfx: function(value) {
      let acctNoSfxDisp = this.acctnosfx.acctNoSfx + '-' + this.acctnosfx.description
      this.riForm.acctNoSfxDesc = acctNoSfxDisp
      this.riForm.acctNoSfx = this.acctnosfx.acctNoSfx
    },
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'riDetailForm.riComm1AE': function(value) {
      if (value) {
        this.recalculate()
      }
    },
    'riDetailForm.riComm2AE': function(value) {
      if (value) {
        this.recalculate()
      }
    },
    'riDetailForm.riComm3AE': function(value) {
      if (value) {
        this.recalculate()
      }
    },
    riOutBordItems: function(value) {
      if (this.riOutBordItems.length > 0) {
        this.disableRiOutRiskPrem = true
      } else {
        this.disableRiOutRiskPrem = false
      }
    }
  },
  computed: {
    disableRelease() {
      return !(this.polTranRel && !this.riTranRel && this.riHeaderItems.length > 0)
    },
    getRIPremiumTotal() {
      let riPremiumTot = 0
      this.riDetailItems.forEach(function(riObj) {
        riPremiumTot = riPremiumTot + riObj.riPrem
      })
      return formatDisplayNumber(riPremiumTot.toFixed(2), 2)
    },
    getRIComm1Total() {
      let riComm1Tot = 0
      this.riDetailItems.forEach(function(riObj) {
        riComm1Tot = riComm1Tot + riObj.riComm1
      })
      return formatDisplayNumber(riComm1Tot.toFixed(2), 2)
    },
    getRIComm2Total() {
      let riComm2Tot = 0
      this.riDetailItems.forEach(function(riObj) {
        riComm2Tot = riComm2Tot + riObj.riComm2
      })
      return formatDisplayNumber(riComm2Tot.toFixed(2), 2)
    },
    getRIComm3Total() {
      let riComm3Tot = 0
      this.riDetailItems.forEach(function(riObj) {
        riComm3Tot = riComm3Tot + riObj.riComm3
      })
      return formatDisplayNumber(riComm3Tot.toFixed(2), 2)
    },
    getRINetPremTotal() {
      let riNetPremTot = 0
      this.riDetailItems.forEach(function(riObj) {
        riNetPremTot = riNetPremTot + riObj.riNetPrem
      })
      return formatDisplayNumber(riNetPremTot.toFixed(2), 2)
    },
    getRILevyTotal() {
      let riLevyTot = 0
      this.riDetailItems.forEach(function(riObj) {
        riLevyTot = riLevyTot + riObj.riLevy
      })
      return formatDisplayNumber(riLevyTot.toFixed(2), 2)
    },
    getRITaxTotal() {
      let riTaxTot = 0
      this.riDetailItems.forEach(function(riObj) {
        riTaxTot = riTaxTot + riObj.riTax
      })
      return formatDisplayNumber(riTaxTot.toFixed(2), 2)
    },
    displayErrorDialog() {
      return this.messages
    },
    tranDateValidation() {
      const result = 'required|riHeader_tranDate:' + this.riForm.tranDateValidationMessage + ',' + this.riForm.tranDateValidation
      return result
    },
    comDateValidation() {
      const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
      return result
    },
    expDateValidation() {
      const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
      return result
    },
    endtDateValidation() {
      const result = 'required|riHeaderEndt_endtDate:' + this.riPrevCesForm.riEndtDate
      return result
    },
    minComDate() {
      if (this.riForm.riComDate !== undefined) {
        let result
        result = this.riForm.riComDate
        return result
      }
      return undefined
    },
    maxComDate() {
      if (this.riForm.riComDate !== undefined) {
        let result
        result = this.riForm.riComDate
        return result
      }
      return undefined
    },
    mode() {
      return this.$route.params.mode
    }
  },
  created() {
    if (this.selectedRi === null) {
      this.$router.push({ name: 'riOutwardList' })
      this.doExit()
    }
    this.doInit()
    if (this.mode === 'query') {
      this.queryMode = true
    } else {
      this.queryMode = false
    }
    this.$validator.extend('riHeader_tranDate', {
      getMessage(field, args) {
        var tranMessage = args[0]
        return `${tranMessage}`
        // return `RI ${field} cannot be earlier than Policy's Commencement Date (10201)`
      },
      validate(value, args) {
        if (value) {
          var comDate = args[1]
          if (comDate === 'true' && args[0] !== undefined) {
            return false
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeader_comDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be earlier than Policy's Commencement Date (10201)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            return !isAfter(removeTime(comDate), removeTime(value))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeader_expDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be later than Policy's Expiry Date (20256)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            return !isAfter(removeTime(value), removeTime(expDate))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeaderEndt_endtDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be earlier than previous cession's Endorsement Date (${formatDisplayDate(args[0])})`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var endtDate = args[0]
          if (endtDate !== undefined && endtDate !== 'undefined') {
            return isAfter(removeTime(value), removeTime(endtDate))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_Date_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        } else return true
      }
    })
  },
  methods: {
    canReview(data) {
      if (data.tranRel === true) {
        return false
      }
      return true
    },
    canRemove(data) {
      if (data.tranRel === true) {
        return false
      }
      return true
    },
    canQuery(data) {
      if (data.tranRel === true) {
        return true
      }
      return false
    },
    async doInitRiReports() {
      await Promise.all([this.$store.dispatch('reportsInit')])
      if (this.$store.state.reports.riReports.init !== 1) {
        await this.$store.dispatch('riReportsInit')
      }
      const apiURI = this.$store.state.reports.riReports.menu.RIClosing
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.riClosingMenu = extractMenu(result.data._links)
          }
        }
      } else {
        this.$toast.error('Missing API URL for RI Closing')
      }
    },
    getRIType(key) {
      for (let riType of this.riTypeList) {
        if (riType.value === key) {
          return riType
        }
      }
      return ''
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    bordEreAuxChanged() {
      if (this.riForm.bordEreAux) {
        if (this.riForm.riType !== 'F') {
          this.checkContractCertaintyDisplay = false
        } else {
          this.checkContractCertaintyDisplay = false
        }
        this.riForm.ccaDate = undefined
        this.riForm.ccdDate = undefined
      } else {
        this.checkContractCertaintyDisplay = true
      }
      this.doShowRiDetails()
    },
    contractCertaintyDisplayChanged() {
      if (this.riForm.bordEreAux) {
        if (this.riForm.riType !== 'F') {
          this.checkContractCertaintyDisplay = false
        } else {
          this.checkContractCertaintyDisplay = false
        }
      } else {
        this.checkContractCertaintyDisplay = true
      }
      if (this.riForm.riType !== 'F') {
        this.checkContractCertaintyDisplay = false
      }
      this.doShowRiDetails()
    },
    checkRiType() {
      if (this.newRiHeader === true) {
        this.doAcctNoSfxInit()
        this.riForm.riCoDesc = undefined
        this.riForm.riCo = undefined
        this.riForm.propXl = 'P'
        this.riForm.acctNoSfx = undefined
        this.riForm.acctNoSfxDesc = undefined
        this.riForm.theirPolNo = undefined
        this.riForm.cesNo = undefined
        this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
        this.riForm.bordEreAux = false
        this.riForm.prtRiApp = false
        this.riForm.relRi = true
        this.riForm.comm1AE = false
        this.riForm.comm1Pct = 0
        this.riForm.comm2AE = false
        this.riForm.comm2Pct = 0
        this.riForm.comm2Gn = 'G'
        this.riForm.comm3AE = false
        this.riForm.comm3Pct = 0
        this.riForm.comm3Gn = 'G'
        this.riForm.stampDuty = 0
        this.riForm.riTax = 0
        this.riForm.riLevy = 0
        if (this.riForm.riType === 'D') {
          // [riOutMaster.riCo] = 'STAT'
          this.riForm.riCo = 'STAT'
          this.riForm.riCoDesc = 'STAT'
          // [riOutMaster.acctNoSfx] = Blank
          this.riForm.acctNoSfx = ''
          // [riOutMaster.propXL] = Blank
          this.riForm.propXl = 'P'
          if (this.newRiHeader) {
            this.riForm.riComm1AE = false
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = true
          }
          this.changeRiCo()
        } else if (this.riForm.riType === 'C') {
          this.riForm.comm1AE = true
          this.riForm.propXl = 'P'
          if (this.acctNoSfxMapData_6) {
            this.riForm.acctNoSfx = this.acctNoSfxMapData_6.acctNoSfx
          } else {
            this.riForm.acctNoSfx = ''
          }
          if (this.newRiHeader) {
            this.riForm.riComm1AE = true
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = true
            this.changeRiCo()
          }
        } else if (this.riForm.riType === 'F') {
          this.riForm.comm1AE = true
          if (this.acctNoSfxMapData_5) {
            this.riForm.acctNoSfx = this.acctNoSfxMapData_5.acctNoSfx
          } else {
            this.riForm.acctNoSfx = ''
          }
          if (this.newRiHeader) {
            this.riForm.riComm1AE = true
            this.riForm.riComm2AE = false
            this.riForm.riComm3AE = false
            this.disableRiBord = false
          }
          this.changeRiCo()
        } else if (this.riForm.riType === 'W') {
          if (this.newRiHeader) {
            this.riForm.prtRiApp = false
            this.disableRiBord = true
          }
          this.changeRiCo()
        } else {
          this.riForm.acctNoSfxDesc = undefined
          this.riForm.acctNoSfx = undefined
          this.riForm.propXl = 'P'
          this.disableRiBord = true
        }
      }
    },
    openRiAppTxt() {
      this.riForm.riAppTxtTemp = this.riForm.riAppTxt
      this.riForm.riAppEndtTxtTemp = this.riForm.riAppEndtTxt
      this.riAppTxtDialog = true
    },
    saveRiAppTxt() {
      this.riForm.riAppTxt = this.riForm.riAppTxtTemp
      this.riForm.riAppEndtTxt = this.riForm.riAppEndtTxtTemp
      this.riAppTxtDialog = false
    },
    async doInit() {
      if (
        (this.selectedRi.appCoIns && parseInt(this.selectedRi.billCoIns) === 1) ||
        (this.selectedRi.appCoIns && this.selectedRi.billCoIns === 'Y')
      ) {
        this.showCoinsSvcFeeBtn = true
      }

      if (this.$store.state.commons.init === 0) {
        await this.$store.dispatch('commonsInit')
      }
      await this.getCommonData('miscparams')
      await this.processRiAutoCession()

      this.doGetCesYr(this.selectedRi.polNo, this.selectedRi.renCnt, this.selectedRi.endtCnt)
      await this.getRiOutMasterList()

      this.doInitRiReports()
    },
    doPromptRelease() {
      this.promptRiRelease = true
    },
    async doRelease() {
      this.riDetailForm.actionName = 'RI_DETAIL_UPDATE'
      this.riDetailSave().then(success3 => {
        if (success3) {
          this.checkTranDate().then(check => {
            if (check) {
              this.$validator.validateAll().then(success1 => {
                if (success1) {
                  this.isReleased = true
                  this.showRiDetails = false
                  this.processingFlag = true
                  this.riForm.actionName = 'RI_HEADER_UPDATE'
                  this.performAction().then(success2 => {
                    if (success2) {
                      this.doReleaseRi().then(success => {
                        if (success) {
                          let riType = this.selectedRi.riType
                          this.riTranRel = true
                          this.doFetch()
                          const apiURI = this.riClosingMenu.export
                          if (apiURI && riType === 'F') {
                            const docForm = {
                              polNo: this.selectedRi.polNo,
                              renCnt: this.selectedRi.renCnt,
                              endtCnt: this.selectedRi.endtCnt,
                              copy: 1,
                              printSection: 0,
                              format: 'PDF',
                              source: 'riRelease'
                            }
                            this.$http
                              .post(apiURI, docForm)
                              .then(result => {
                                this.processingFlag = false
                              })
                              .catch(err => {
                                const { data } = err.response
                                if (data) {
                                  this.message(data)
                                  this.fieldMessage(data)
                                }
                                this.processingFlag = false
                              })
                          } else {
                            this.processingFlag = false
                          }
                        } else {
                          this.processingFlag = false
                        }
                      })
                    } else {
                      this.promptFieldCheck()
                      this.processingFlag = false
                    }
                  })
                } else {
                  this.promptFieldCheck()
                  this.processingFlag = false
                }
              })
            }
          })
        } else {
          this.promptFieldCheck()
          this.processingFlag = false
        }
      })
    },
    doColumn(riTab, columns) {
      this.doCancelDetail()
      this.doCancel()
      this.doFetch(false).then(() => {
        if (this.riHeaderItems.length > 0) {
          this.doEdit(this.riHeaderItems[0])
        }
      })
    },
    doCoinsSvcFee() {
      this.coinsSvcFeeDialog = true
    },
    doNewRiHeader() {},
    doShowRiCo() {
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W' || this.riForm.riType === 'D') {
        this.riTreatyDialog = true
        this.riTreatyInit()
      } else if (this.riForm.riType === 'C' || this.riForm.riType === 'F') {
        this.riCoDialog = true
        this.riCoInit()
      }
    },
    doShowAcctNoSfx() {
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(5)
      }
    },
    doAcctNoSfxInit() {
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxInit(5)
      }
    },
    doClose() {
      this.riCoDialog = false
      this.riTreatyDialog = false
      this.riAcctNoSfxDialog = false
    },
    doCancel() {
      if (this.newRiHeader === true) {
        this.reviewRI = false
        this.riForm.riType = undefined
        this.riForm.riCoDesc = undefined
        this.riForm.riCoWithDesc = undefined
        this.riForm.acctNoSfxWithDesc = undefined
        this.riForm.comm1PctAE = false
        this.riForm.comm2Gn = undefined
        this.riForm.riCo = undefined
        this.riForm.propXl = undefined
        this.riForm.acctNoSfx = undefined
        this.riForm.acctNoSfxDesc = undefined
        this.riForm.theirPolNo = undefined
        this.riForm.cesNo = undefined
        this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
        this.riForm.bordEreAux = false
        this.riForm.prtRiApp = false
        this.riForm.relRi = true
        this.riForm.tranDate = undefined
        this.riForm.riComDate = undefined
        this.riForm.riExpDate = undefined
        this.riForm.relDate = undefined
        this.riForm.comm1AE = false
        this.riForm.comm1Pct = 0
        this.riForm.comm2AE = false
        this.riForm.comm2Pct = 0
        this.riForm.comm2Gn = 'G'
        this.riForm.comm3AE = false
        this.riForm.comm3Pct = 0
        this.riForm.comm3Gn = 'G'
        this.riForm.stampDuty = 0
        this.riForm.riTax = 0
        this.riForm.riLevy = 0
        this.riForm.relUsr = undefined
        this.riHeaderPanel = false
        this.resetActiveRow()
      } else {
        this.showRiHeader = false
      }
    },
    doCancelDetail() {
      if (this.newRiHeader === true) {
        this.riDetailForm.riskGrpNo = undefined
        this.riDetailForm.riskNo = undefined
        this.riDetailForm.riskDesc = undefined
        this.riDetailForm.riSI = undefined
        this.riDetailForm.riSIAE = true
        this.riDetailForm.riSIPct = undefined
        this.riDetailForm.riSIPctAE = true
        this.riDetailForm.riPrem = undefined
        this.riDetailForm.riPremAE = true
        this.riDetailForm.prtyLim = undefined
        this.riDetailForm.riComm1AE = true
        this.riDetailForm.riComm1 = undefined
        this.riDetailForm.riComm2AE = true
        this.riDetailForm.riComm2 = undefined
        this.riDetailForm.riComm3AE = true
        this.riDetailForm.riComm3 = undefined
        this.riDetailForm.riTax = undefined
        this.riDetailForm.riTaxAE = true
        this.riDetailForm.riLevy = undefined
        this.riDetailForm.riLevyAE = true
        this.riDetailPanel = false
      } else {
        this.showRiDetailsForm = false
      }
    },
    async doSaveRiHeader() {
      this.resetMessages()
      this.tab = 'RI Header'
      if (this.newRiHeader === false) {
        this.checkTranDate().then(check => {
          this.$validator.validateAll().then(success1 => {
            if (success1) {
              this.processingFlag = true
              this.riForm.actionName = 'RI_HEADER_UPDATE'
              this.performAction().then(success => {
                if (success) {
                  this.showRiForm = false
                  this.getRiOutMasterList()
                  if (this.riForm.riType === 'F' || this.riForm.riType === 'T') {
                    if (this.riOutBordItems.length > 0) {
                      this.updateRiOutBord().then(riOutBord => {
                        if (riOutBord !== false) {
                          this.doFetchRiOutBordList(riOutBord)
                        }
                      })
                    }
                  }
                }
                this.processingFlag = false
              })
            } else {
              this.promptFieldCheck()
              this.processingFlag = false
            }
          })
        })
      } else {
        this.$validator.validateAll().then(success => {
          if (success) {
            this.riForm.actionName = 'RI_HEADER_CREATE'
            this.performAction().then(result => {
              if (result) {
                this.selectedRow = this.riForm
                this.processingFlag = false
                if (this.newRiHeader && (this.riForm.riType === 'F' || this.riForm.riType === 'T')) {
                  this.createRiOutBord().then(riOutBord => {
                    if (riOutBord !== false) {
                      this.doFetchRiOutBordList(riOutBord)
                    }
                    this.doEdit(this.selectedRow)
                  })
                }
              }
            })
          } else {
            this.promptFieldCheck()
            this.processingFlag = false
          }
        })
      }
    },
    doRiOutBordDetailEdit(riDetail) {
      this.doFetchRiOutBord(riDetail)
    },
    doSaveRiDetail() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newRiDetail === false) {
            this.riDetailForm.actionName = 'RI_DETAIL_UPDATE'
            this.riDetailSave().then(result => {
              this.riDetailPanel = false
            })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSaveRiOutBord() {
      this.resetMessages()
      this.processingFlag = true
      if (this.newRiOutBord === false) {
        this.updateRiOutBord().then(result => {
          if (result) {
            this.processingFlag = false
            this.doFetchRiOutBordList(this.riDetailForm)
          }
        })
      } else {
        this.$validator.validateAll().then(success => {
          if (success) {
            this.createRiOutBord().then(result => {
              if (result) {
                this.selectedRiOutBordRow = this.riForm
                this.doEditRiOutBord(this.selectedRiOutBordRow)
                this.processingFlag = false
                this.doFetchRiOutBordList(this.riDetailForm)
              }
            })
          } else {
            this.promptFieldCheck()
            this.processingFlag = false
          }
        })
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doQuery(data) {
      this.doEdit(data)
    },
    doEdit(data) {
      this.selectedRi.riType = data.riType
      this.selectedRi.riCo = data.riCo
      this.riTranRel = data.tranRel
      if (data.tranRel === true) {
        this.isReleased = true
      } else {
        this.isReleased = false
      }
      this.riHeaderDisplay = data.riType + ' / ' + data.riCo + ' / ' + data.acctNoSfx + ' -'
      this.resetMessages()
      this.showRiHeader = true
      this.activateRow(data)
      this.reviewRI = true
      this.newRiHeader = false
      this.riHeaderPanel = true
      this.doFetchRiHeader(data).then(() => {
        if (data.cesEndtCnt > 0) {
          this.doFetchPrevCesRiHeader(data)
        }
        this.doShowRiDetails()
        this.doAcctNoSfxInit()
      })
    },
    async doEditRiOutBord(data) {
      this.resetMessages()
      this.activeRowRiOutBord(data)
      this.newRiOutBord = false
      this.editRiOutBord = true
      this.queryRiOutBord = false
      await this.doFetchRiOutBord(data)
      this.changeRiPremAE()
      this.changeRiCommAE()
    },
    async doQueryRiOutBord(data) {
      this.resetMessages()
      this.showRiOutBord = true
      this.activeRowRiOutBord(data)
      this.newRiOutBord = false
      this.editRiOutBord = false
      this.queryRiOutBord = true
      await this.doFetchRiOutBord(data)
    },
    activateRow(row) {
      this.selectedRecord = row.polNo + '-' + row.riType + '-' + row.riCo + '-' + row.acctNoSfx + '-' + row.cesEndtCnt
      this.selectedRow = row
    },
    activeRowRiOutBord(props) {
      this.selectedRiOutBordRecord = parseInt(props.itemNo)
    },
    async doBack() {
      if (this.queryMode) {
        this.$router.push({ name: 'riOutwardList' })
        this.doExit()
      } else {
        this.$router.push({ name: 'riOutwardList' })
      }
    },
    async getRiOutMasterList() {
      this.selectedRi.riskGrpNo = this.riForm.riskGrpNo
      this.selectedRi.riskNo = this.riForm.riskNo
      this.doFetch(false).then(() => {
        if (this.riHeaderItems.length > 0) {
          this.doEdit(this.riHeaderItems[0])
        } else {
          this.checkPolBordItem(this.selectedRi).then(result => {})
        }
      })
    },
    doAdd() {
      this.riHeaderDisplay = ''
      this.isReleased = false
      this.newRiHeader = true
      this.riHeaderPanel = true
      this.riForm.tranDate = (this.selectedRi || {}).tranDate
      this.riForm.riComDate = (this.selectedRi || {}).comDate
      this.riForm.riExpDate = (this.selectedRi || {}).expDate
      this.riForm.relDate = undefined
      this.riForm.riType = undefined
      this.riForm.riCoDesc = undefined
      this.riForm.riCoWithDesc = undefined
      this.riForm.acctNoSfxWithDesc = undefined
      this.riForm.comm1PctAE = false
      this.riForm.comm2Gn = undefined
      this.riForm.riCo = undefined
      this.riForm.propXl = 'P'
      this.riForm.acctNoSfx = undefined
      this.riForm.acctNoSfxDesc = undefined
      this.riForm.theirPolNo = undefined
      this.riForm.cesNo = undefined
      this.riForm.cesYr = this.defCesYr ? this.uwYr : removeTime((this.selectedRi || {}).tranDate).getFullYear()
      this.riForm.bordEreAux = false
      this.riForm.prtRiApp = false
      this.riForm.relRi = true
      this.riForm.comm1AE = false
      this.riForm.comm1Pct = formatDisplayNumber(0, 6)
      this.riForm.comm2AE = false
      this.riForm.comm2Pct = formatDisplayNumber(0, 6)
      this.riForm.comm2Gn = 'G'
      this.riForm.comm3AE = false
      this.riForm.comm3Pct = formatDisplayNumber(0, 6)
      this.riForm.comm3Gn = 'G'
      this.riForm.stampDuty = 0
      this.riForm.riTax = 0
      this.riForm.riLevy = 0
      this.riForm.ccaDate = undefined
      this.riForm.ccdDate = undefined
      this.riForm.riAppTxt = undefined
      this.riForm.riAppEndtTxt = undefined
      this.riForm.riAppTxtTemp = undefined
      this.riForm.riAppEndtTxtTemp = undefined
      this.riForm.relUsr = undefined
      this.resetActiveRow()
      this.resetRiDetails()
    },
    async doAddRiOutBord() {
      this.newRiOutBord = true
      this.editRiOutBord = false
      this.queryRiOutBord = false
      this.doFetchRiOutBordItem(this.riForm).then(() => {
        this.riForm.riTypeCo = this.riForm.riType + ' / ' + this.riForm.riCo + ' - ' + this.riForm.riCoDesc
        this.riForm.cedPolNo = undefined
        this.riForm.riSIAE = false
        this.riForm.riSI = 0
        this.riForm.riSIPct = 0
        this.riForm.riPremAE = true
        this.riForm.riPrem = 0
        this.riForm.riComm1AE = true
        this.riForm.riComm1 = 0
        this.riForm.riComm2AE = true
        this.riForm.riComm2 = 0
        this.riForm.riComm3AE = true
        this.riForm.riComm3 = 0

        this.showRiOutBord = true
      })
    },
    resetRiDetails() {
      this.showRiDetails = false
      this.showRiDetailsForm = false
      this.showRiHeader = true
      this.riDetailItems = []
      this.doCancelDetail()
    },
    resetActiveRow() {
      const rows = Array.from(document.querySelectorAll('tr.activeRow'))
      rows.forEach(row => {
        row.classList.remove('activeRow')
      })
      this.selectedRecord = {}
    },
    resetActiveRowRiOutBord() {
      const rows = Array.from(document.querySelectorAll('tr.activeRowRiOutBord'))
      rows.forEach(row => {
        row.classList.remove('activeRowRiOutBord')
      })
      this.selectedRiOutBordRecord = {}
    },
    doShowRiDetails() {
      if (!this.showRiOutBord) {
        this.showRiDetails = true
      } else {
        this.showRiDetails = false
      }
      this.doReview(this.selectedRow).then(() => {
        if (this.riDetailItems.length > 0) {
          this.doDetailEdit(this.riDetailItems[0])
        }
      })
    },
    doShowRiOutBordDetails() {
      this.showRiOutBord = true
      this.doRiOutBordReview(this.selectedRiOutBordRow).then(() => {
        if (this.riOutBordItems.length > 0) {
          this.doRiOutBordDetailEdit(this.riOutBordItems[0])
        }
      })
    },
    async doDelete() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.deleteRiHeader
      if (apiURI) {
        const expand = this.selectedRIHeader
        await this.$http
          .post(apiURI, expand)
          .then(result => {
            const data = result.data
            this.notify(data)
            this.doFetch(false).then(() => {
              if (this.riHeaderItems.length > 0) {
                this.doEdit(this.riHeaderItems[0])
              }
            })
          })
          .catch(err => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    async doDeleteRiOutBord() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.deleteRiOutBord
      if (apiURI) {
        this.selectedRiOutBord.riSI = removeFormatNumber(this.selectedRiOutBord.riSI)
        this.selectedRiOutBord.riSIPct = removeFormatNumber(this.selectedRiOutBord.riSIPct)
        this.selectedRiOutBord.riPrem = removeFormatNumber(this.selectedRiOutBord.riPrem)
        this.selectedRiOutBord.riComm1 = removeFormatNumber(this.selectedRiOutBord.riComm1)
        this.selectedRiOutBord.riComm2 = removeFormatNumber(this.selectedRiOutBord.riComm2)
        this.selectedRiOutBord.riComm3 = removeFormatNumber(this.selectedRiOutBord.riComm3)
        const expand = this.selectedRiOutBord
        await this.$http
          .post(apiURI, expand)
          .then(result => {
            const data = result.data
            this.notify(data)
            this.doFetchRiOutBordList(this.riDetailForm).then(result => {
              if (result !== false) {
                this.doEditRiOutBord(this.riOutBordItems[0])
              } else {
                this.resetRiOutBord()
              }
            })
          })
          .catch(err => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    resetRiOutBord() {
      this.riForm.itemNo = undefined
      this.riForm.cedPolNo = undefined
      this.riForm.riSIAE = false
      this.riForm.riSI = 0
      this.riForm.riSIPct = 0
      this.riForm.riPremAE = true
      this.riForm.riPrem = 0
      this.riForm.riComm1AE = true
      this.riForm.riComm1 = 0
      this.riForm.riComm2AE = true
      this.riForm.riComm2 = 0
      this.riForm.riComm3AE = true
      this.riForm.riComm3 = 0
      this.riForm.riTypeCo = undefined
    },
    changeRiPremAE() {
      if (this.riForm.riPremAE) {
        this.disableRiPrem = true
      } else {
        this.disableRiPrem = false
      }
    },
    changeRiComm1AE() {
      if (this.riForm.riComm1AE) {
        this.disableRiComm1 = true
      } else {
        this.disableRiComm1 = false
      }
      if (this.riForm.riComm2AE) {
        this.disableRiComm2 = true
      } else {
        this.disableRiComm2 = false
      }
      if (this.riForm.riComm3AE) {
        this.disableRiComm3 = true
      } else {
        this.disableRiComm3 = false
      }
    },
    changeRiCommAE() {
      if (this.riForm.riComm1AE) {
        this.disableRiComm1 = true
      } else {
        this.disableRiComm1 = false
      }
      if (this.riForm.riComm2AE) {
        this.disableRiComm2 = true
      } else {
        this.disableRiComm2 = false
      }
      if (this.riForm.riComm3AE) {
        this.disableRiComm3 = true
      } else {
        this.disableRiComm3 = false
      }
    },
    doReviewDetails(data) {
      this.showRiDetailsForm = true
      this.doDetailEdit(data)
      this.$nextTick(() => {
        this.$vuetify.goTo('#riDetailFormCard')
      })
    },
    doReviewRiOutBordDetails(data) {
      this.doRiOutBordDetailEdit(data)
    },
    async doDetailEdit(data) {
      this.selectedRi.riskGrpNo = data.riskGrpNo
      this.selectedRi.riskNo = data.riskNo
      this.newRiDetail = false
      this.riDetailTab = false
      this.riDetailPanel = true
      await this.doFetchRiDetail(data).then(result1 => {
        if (result1) {
          this.doFetchRiOutBordList(this.riDetailForm).then(result => {
            if (result === false) {
              this.resetRiOutBord()
            } else {
              if (this.riOutBordItems.length > 0) {
                this.showRiOutBord = true
                this.doEditRiOutBord(this.riOutBordItems[0])
              } else {
                this.showRiOutBord = false
              }
            }
          })
        }
      })
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    doPromptRemove(item) {
      this.promptRemove = true
      this.labels.promptRemove = 'You have chosen to delete this ' + item.riCo + ' record. Do you really want to delete this record?'
      this.selectedRIHeader = item
      this.deleteRIHeader = item.riType + ' - ' + item.riCo
    },
    doPromptRemoveRiOutBord(item) {
      this.promptRemoveRiOutBord = true
      this.labels.promptRemoveRiOutBord =
        'You have chosen to delete this Item No. ' + item.itemNo + ' record. Do you really want to delete this record?'
      this.selectedRiOutBord = item
      this.deleteRiOutBord = 'Item No.: ' + item.itemNo
    },
    canEndorse(data) {
      if (this.listMode === 'Endorsement' && data.tranRel) {
        return true
      } else {
        return false
      }
    },
    async doEndorse(item) {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.endorseRi
      if (apiURI) {
        try {
          const expand = clone(item)
          if (this.miscparams) {
            expand.riDisc = this.miscparams.riDisc
            expand.dtChgRIDiscImpl = this.miscparams.dtChgRIDiscImpl
          }
          const result = await this.$http.post(apiURI, item)
          const { data } = result
          if (data) {
            item.tranRel = false // to enable review/edit mode
            item.cesEndtCnt += 1 // to fetch newly endorse record
            this.doEdit(item)
            this.notify(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatMoney(val) {
      return formatPrice(val)
    },
    async doGetCesYr(polNo, renCnt, endtCnt) {
      const expand = {
        polNo: polNo,
        renCnt: renCnt,
        endtCnt: endtCnt
      }
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.getCesYrInfo
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.defCesYr = result.data.data.defCesYr
            this.uwYr = result.data.data.uwYr
            this.billCurrDesc = result.data.data.billCurrDesc
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  props: {
    selectedRi: {
      type: Object,
      default: null
    },
    listMode: {
      type: String,
      default: 'Reinsurance'
    }
  },
  components: {
    riLifeCycle,
    PromptLeave,
    riCoinsuranceServiceFee
  },
  mixins: [MessageMixin, riAjaxMixin, riListMixin, commonMixins, commonAjaxMixin, promptOnExitMixin, TableConst.default]
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
.activeRow {
  background-color: #fff9c4ff;
}
.activeRowRiOutBord {
  background-color: #fff9c4ff;
}
.table-action-custom {
  text-align: center !important;
  width: 94px !important;
  max-width: 94px !important;
  min-width: 94px !important;
}
.table-space {
  width: 94px !important;
  max-width: 94px !important;
  min-width: 94px !important;
}
</style>
